

define(['angular', 'squid/index', 'components/node-uuid/uuid' // Using the same module as used in NodeInfra
], function (angular, squid, uuid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('tracking.model', ['squid']).constant('$FptiConstants', {
        // The prototype of buzname data object
        buznameMap: {
            country: {
                placeHolder: 'glb',
                fptiKey: 'ccpg'
            },

            flowgatename: {
                placeHolder: '',
                fptiKey: 'fltp'
            },

            'flowname': {
                placeHolder: 'ec:hermes:',
                fptiKey: 'flnm'
            },
            'hier1': {
                placeHolder: 'main_ec_hermes_',
                fptiKey: 'shir'
            },
            /*
             * No key defined in FPTI
             */
            //            'hier2': '',
            //            'hier3': '',
            //            'hier4': '',
            //            'hier5': '',
            'inout': {
                placeHolder: 'inout',
                fptiKey: 'lgin'
            },
            'pagename': {
                placeHolder: 'main:ec:hermes',
                fptiKey: 'pgrp'
            },
            'pagename2': {
                placeHolder: 'main:ec:hermes',
                fptiKey: 'page'
            },
            'version': {
                placeHolder: 'hermes',
                fptiKey: 'vers'
            }
            /*
             * Deprecated SiteCatalyst keys
             */
            //            'feature': 'ec',
            //            'oldpagename': '',
            //            'product': ';ec',
            //            'subfeature1': 'hermes',
            //            'subfeature2': '',
            //            'website': 'main'
        },

        // Full list of FPTI keys indexed by readable names
        // This mapping can also be served as default decorator
        fptiKeys: {
            'businessType': 'bztp',
            'correlationId': 'calc', // CalDataModel
            'countryOfPage': 'ccpg', // buzname
            'cust': 'cust',
            'errorCode': 'eccd',
            'fieldError': 'erfd',
            'flowgatename': 'fltp', // buzname
            'flowname': 'flnm', // buzname
            'locale': 'rsta', // LocaleModel
            'loggedIn': 'lgin', // buzname
            'merchantId': 'mrid',
            'merchantType': 'mbtp',
            'pageError': 'erpg',
            'pageGoal': 'goal', // route
            'pageGroup': 'pgrp', // buzname
            'pageName': 'page', // buzname
            'pageQualifer': 'qual', // buzname
            'pageStartTime': 'pgst', // FptiBuilder
            'pageTechnologyFlag': 'pgtf', // productConfig
            'paymentFlowId': 'pfid',
            'rLogId': 'teal',
            'sessionId': 'fpti',
            'siteHierarchy': 'shir', // buzname
            'sourceCi': 's', // productConfig
            'tealeaf': 'teal',
            'templateName': 'tmpl', // route
            'transition_time': 'transition_time',
            'uuid': 'csci', // CalDataModel
            'version': 'vers', // buzname
            'visitorId': 'vid',
            'ecToken': 'fltk', // metadata
            'pxpExpSelected': 'xe',
            'pxpTreatementSelected': 'xt',
            'pxpQualifiedTreatment': 'qt',
            'pxpContextId': 'qc',
            'dc': 'dc',
            'az': 'az'
        },

        landing_page: {
            login: 'LOGIN',
            econsent: 'eConsent',
            review: 'Review',
            error_page: 'error_page',
            add_card: 'add_card',
            add_bank: 'add_bank',
            billing: 'billing',
            done_page: 'done_page',
            shoppingCart: 'shoppingCart',
            emptyCart: 'emptyCart',
            soldout: 'soldout',
            openButton: 'openButton'
        },

        stateName: {
            checkout_login: 'login',
            checkout_genericError: 'error_page',
            checkout_fastlogin: 'login',
            checkout_econsent: 'econsent',
            checkout_review: 'review',
            checkout_pageAddCard_addCardFlow_addCard: 'add_card',
            checkout_updateCard_addCardFlow_addCard: 'add_card',
            checkout_pageAddFi_bank_add: 'add_bank',
            guest: 'billing',
            checkout_done: 'done_page',
            checkout_guest: 'billing',
            checkout_signup: 'billing',
            guestupgrade_genericError: 'error_page',
            checkout_multistepsignup_multistepsignupaddcard: 'billing',
            checkout_shoppingCart: 'shoppingCart',
            checkout_emptyCart: 'emptyCart',
            checkout_soldout: 'soldout',
            checkout_openButton: 'openButton'
        }
    }).factory('$FptiDataModel', function ($Class, $FptiConstants, $util, $config) {
        var productConfig = {};
        // TODO to read from config.json
        productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
        productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

        /**
         * Utilizing Decorator pattern to allow defining additional logic for specific keys
         */
        return $Class.extend('FptiDataModel', {
            init: function init() {
                this._dataObj = angular.extend({}, productConfig);
                this._decoratorList = [];
            },
            decorators: {
                buzname: function buzname(trackingData, pageQualifier, isInContext) {

                    if (!trackingData) {
                        return;
                    }

                    var buzname = trackingData.buzname;
                    if (!buzname) {
                        return;
                    }

                    var buznameDiff = buzname[pageQualifier];
                    if (!buznameDiff) {
                        return;
                    }

                    var dataObj = this._dataObj;
                    var buznameMap = $FptiConstants.buznameMap;
                    // read app specific place holder from config
                    var placeHolderConfig = $config && $config.fpti && $config.fpti.buznameEntryPlaceHolder;

                    Object.keys(buznameMap).forEach(function (key) {
                        var buznameEntry = buznameMap[key];
                        var fptiKey = buznameEntry.fptiKey;
                        var placeHolder = buznameEntry.placeHolder;

                        if (buznameDiff[key]) {
                            if (placeHolderConfig && placeHolderConfig[key]) {
                                placeHolder = placeHolderConfig[key];
                            }
                            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
                        } else {
                            dataObj[fptiKey] = placeHolder;
                        }
                    });
                    dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
                },

                locale: function locale(_locale) {
                    if (_locale && _locale.country) {
                        this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
                    }
                },

                pxptrackingdata: function pxptrackingdata(pxpData) {
                    var qt = [];
                    var qc = [];
                    var xe = [];
                    var xt = [];
                    $util.some(pxpData, function (trackInfo) {
                        var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
                        if (match) {
                            qt.push(match[1]);
                        }

                        match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
                        if (match) {
                            qc.push(match[1]);
                        }

                        $util.some(trackInfo.treatments, function (treatment) {
                            xe.push(treatment.experiment_id);
                            xt.push(treatment.treatment_id);
                        });
                    });

                    this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
                    this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
                    this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
                    this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
                },

                templateName: function templateName(trackingData, pageQualifier, isInContext) {
                    if (trackingData && trackingData.templateName) {
                        var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');

                        this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
                    }
                },

                fieldError: function fieldError(err) {
                    if (err && err.type === 'fieldError') {
                        this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                    }
                },

                pageError: function pageError(err) {
                    if (err && err.type === 'pageError') {

                        this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                    }
                }

            },
            decorate: function decorate(name) {
                this._decoratorList.push({
                    name: name,
                    params: Array.prototype.slice.call(arguments, 1)
                });
                return this;
            },
            getDataObject: function getDataObject(isInContext) {
                var i;
                var decorator;

                for (i = 0; i < this._decoratorList.length; i++) {
                    decorator = this._decoratorList[i];
                    if (!decorator) {
                        continue;
                    }
                    var name = decorator.name;
                    var params = decorator.params;
                    if (angular.isFunction(this.decorators[name])) {
                        // Invoke the decorator and pass in the parameter list
                        this.decorators[name].apply(this, params);
                    } else {
                        var fptiKey = $FptiConstants.fptiKeys[name];
                        // If the fptiKey is defined and value is present, add the k-v pair
                        if (fptiKey && params && params.length > 0) {
                            this._dataObj[fptiKey] = params[0];
                        }
                    }
                }

                // 'fullpage' was widely used as default key in page routs definition
                // finally replace it here if it's incontext
                var dataObj = this._dataObj;
                if (isInContext) {
                    Object.keys(dataObj).forEach(function (k) {
                        if (angular.isString(dataObj[k])) {
                            // some values can be number
                            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
                        }
                    });
                }

                return this._dataObj;
            }
        });
    }).factory('$CalDataModel', function ($Model) {

        var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';

        function _generateCorrelationId() {
            var uidRandomArr = (uuid.v4() || uuid_v4_mask).split('-');
            var uidTime = (uuid.v1() || uuid_v1_mask).split('-');
            return uidTime[0] + uidRandomArr[0].substr(0, 5);
        }

        function _generateUUID() {
            return (uuid.v4() || uuid_v4_mask).replace(/-/g, '');
        }

        var CalModel = $Model.extend({
            _calCorrId: _generateCorrelationId(),
            _uuid: _generateUUID(),

            generateCalCorrId: function generateCalCorrId() {
                this._calCorrId = _generateCorrelationId();
            },
            generateUUID: function generateUUID() {
                this._uuid = _generateUUID();
            },
            generateMetaIds: function generateMetaIds() {
                this.generateCalCorrId();
                this.generateUUID();
            },

            getCalCorrId: function getCalCorrId() {
                return this._calCorrId;
            },

            getUUID: function getUUID() {
                return this._uuid;
            }
        });

        return new CalModel();
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/model.js
// module id = ./components/xo-tracking/dist/model.js
// module chunks = 1